export default {
  // setLoading({commit}, loading) {
  //   commit('setLoading', loading);
  // },
  setToken({commit}, token) {
    commit('setToken', token);
  },
  logout({commit}) {
    commit('logout');
  },
  setPersonName({commit}, personName) {
    commit('setPersonName', personName);
  },
  setPhoneNumber({commit}, phoneNumber) {
    commit('setPhoneNumber', phoneNumber);
  },
  setDeliveryIdnumber({commit}, deliveryIdnumber) {
    commit('setDeliveryIdnumber', deliveryIdnumber);
  },
  setUserId({commit}, userId) {
    commit('setUserId', userId);
  },
  setOrgunit({commit}, orgunit) {
    commit('setOrgunit', orgunit);
  },
  setDeliveryId({commit}, deliveryId) {
    commit('setDeliveryId', deliveryId);
  },
  setAccessToken({commit}, accessToken) {
    commit('setAccessToken', accessToken);
  },
  setPersonId({commit}, personId) {
    commit('setPersonId', personId);
  },
  // setBreadcrumb({commit}, breadcrumb) {
  //   commit('setBreadcrumb', breadcrumb)
  // },
  // setLayout({commit}, layout) {
  //   commit('setLayout', layout)
  // },
  // setSelectedMenu({commit}, menu) {
  //   commit('setSelectedMenu', menu);
  // },
  // setUserName({commit}, name) {
  //   commit('setUserName', name)
  // },
  // setUserId({commit}, id) {
  //   commit('setUserId', id)
  // },
  // setTools({commit}, tools) {
  //   commit('setTools', tools)
  // }
}